import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

function matches(query: string): boolean {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  } catch {
    return false;
  }
}

/**
 * True on a phone or tablet, where an `sms:` link opens the Messages app.
 * The user agent covers phones; the coarse-pointer check covers iPadOS, which
 * reports a desktop Mac user agent.
 */
export function isTextCapableDevice(): boolean {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)) return true;
  return matches('(pointer: coarse)');
}

/** Opens the native Messages app with the prefilled body from Nova's `sms_link`. */
export function openSmsLink(smsLink: string): void {
  window.location.assign(smsLink);
}

export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(() => matches(REDUCED_MOTION_QUERY));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    let query: MediaQueryList;
    try {
      query = window.matchMedia(REDUCED_MOTION_QUERY);
    } catch {
      return;
    }
    const onChange = () => setReduced(query.matches);
    query.addEventListener?.('change', onChange);
    return () => query.removeEventListener?.('change', onChange);
  }, []);

  return reduced;
}
